export default __webpack_public_path__ + "static/media/tooltip-white.af54810e.svg";